import { Reducer } from "react";
import { ActionType, actions } from "./action";
import { TypeCommon } from "models/common";

export type GlobalStateType = {
  listOrg?: TypeCommon;
  userServices?: TypeCommon;
  forceChangePassword?: boolean;
};

export const initialGlobalState: GlobalStateType = {
  listOrg: [],
  userServices: [],
  forceChangePassword: false,
};

const reducers: Reducer<GlobalStateType, ActionType> = (
  state: GlobalStateType,
  action: ActionType,
) => {
  switch (action.type) {
    case actions.GET_LIST_ORGANIZATION:
      return {
        ...state,
        listOrg: action.payload,
      };
    case actions.GET_USER_DETAIL:
      return {
        ...state,
        userServices: action.payload,
      };
    case actions.RESET_USER_DATA:
      return {
        ...state,
        userServices: action.payload,
      };
    case actions.FORCE_CHANGE_PASSWORD:
      return {
        ...state,
        forceChangePassword: true,
      };
    case actions.RESET_FORCE_CHANGE_PASSWORD:
      return {
        ...state,
        forceChangePassword: false,
      };
    default:
      return state;
  }
};

export default reducers;
